module.exports = __webpack_public_path__ + "img/wrong_intent_icon.cad769e1.svg";